import React, { useRef, useState, useEffect } from 'react';
import '../styles/WebcamComponent.css';

const WebcamComponent = () => {

    const videoRef = useRef(null);
    const outputCanvasRef = useRef(null);
    const fullCanvasRef = useRef(null);
    const netRef = useRef(null);
    const animationFrameId = useRef(null);
    const containerRef = useRef(null);
    const [isWebcamOn, setIsWebcamOn] = useState(false);
    const [position, setPosition] = useState({  x: window.innerWidth - 260, y: 193  });
    const [dragging, setDragging] = useState(false);
    const [rel, setRel] = useState({ x: 0, y: 0 });

    //Initializes and starts the webcam stream, Requests user permission and handles the media stream
    const startWebcam = async () => {
        try {
            const stream = await navigator.mediaDevices.getUserMedia({ 
                video: true,
            audio : false
         });
            videoRef.current.srcObject = stream;
            videoRef.current.onloadedmetadata = () => {
              videoRef.current.play();
              setIsWebcamOn(true);
            };
          } catch (err) {
        console.error("Error accessing webcam:", err);
        alert("Could not access webcam. Please make sure you have granted permission.");
        }
    };

    useEffect(() => {
        if (!isWebcamOn || !netRef.current || !outputCanvasRef.current || !fullCanvasRef.current) return;
      
        const video = videoRef.current;
        const outputCanvas = outputCanvasRef.current;
        const fullCanvas = fullCanvasRef.current;
        const outputCtx = outputCanvas.getContext('2d');
      
        let isActive = true;
      
        const waitForVideoReady = () => {
          if (!video.videoWidth || !video.videoHeight) {
            requestAnimationFrame(waitForVideoReady);
            return;
          }
      
          fullCanvas.width = video.videoWidth;
          fullCanvas.height = video.videoHeight;
      
          outputCanvas.width = 170;
          outputCanvas.height = 130;
      
          async function segmentFrame() {
            if (!isActive) return;
      
            try {
              const segmentation = await netRef.current.segmentPerson(video, {
                internalResolution: 'medium',
                segmentationThreshold: 0.7,
              });
      
              // Prevent drawing from canvas with 0 size
              if (fullCanvas.width === 0 || fullCanvas.height === 0) return;
      
              outputCtx.clearRect(0, 0, outputCanvas.width, outputCanvas.height);
              outputCtx.drawImage(
                fullCanvas,
                position.x,
                position.y,
                outputCanvas.width,
                outputCanvas.height,
                0,
                0,
                outputCanvas.width,
                outputCanvas.height
              );
      
              animationFrameId.current = requestAnimationFrame(segmentFrame);
            } catch (err) {
              console.error("Segmentation error:", err);
            }
          }
      
          segmentFrame();
        };
      
        waitForVideoReady();
      
        return () => {
          isActive = false;
          if (animationFrameId.current) cancelAnimationFrame(animationFrameId.current);
        };
      }, [isWebcamOn, position]);
      
    

    //Stops the webcam stream and cleans up resources
    const stopWebcam = () => {
        if (videoRef.current && videoRef.current.srcObject) {
        const tracks = videoRef.current.srcObject.getTracks();
        tracks.forEach(track => track.stop());
        videoRef.current.srcObject = null;
        setIsWebcamOn(false);
        }
    };

    //Toggles the webcam on/off
    const toggleWebcam = () => {
        if (isWebcamOn) {
            stopWebcam();
        } else {
            startWebcam();
        }
    };

    // Cleanup on component unmount
    useEffect(() => {
        return () => {
            stopWebcam();
        };
    }, []);

    // Mouse events for dragging
    const handleMouseDown = (e) => {
        if (e.button !== 0) return;
        const bounds = containerRef.current.getBoundingClientRect();
        setRel({
            x: e.pageX - bounds.left,
            y: e.pageY - bounds.top
        });
        setDragging(true);
        e.stopPropagation();
        e.preventDefault();
    };

    const handleMouseMove = (e) => {
        if (!dragging) return;
        setPosition({
            x: e.pageX - rel.x,
            y: e.pageY - rel.y
        });
        e.stopPropagation();
        e.preventDefault();
    };

    const handleMouseUp = () => {
        setDragging(false);
    };

    useEffect(() => {
        if (dragging) {
            document.addEventListener('mousemove', handleMouseMove);
            document.addEventListener('mouseup', handleMouseUp);
        } else {
            document.removeEventListener('mousemove', handleMouseMove);
            document.removeEventListener('mouseup', handleMouseUp);
        }
        return () => {
            document.removeEventListener('mousemove', handleMouseMove);
            document.removeEventListener('mouseup', handleMouseUp);
        };
    }, [dragging]);

    return (
        <div className="webcam-container draggable"
        ref={containerRef}
        onMouseDown={handleMouseDown}
        style={{ left: `${position.x}px`, top: `${position.y}px` }}
        >
        <button 
            onClick={toggleWebcam}
            className={`webcam-toggle ${isWebcamOn ? 'on' : 'off'}`}
        >
            <i className={`fas ${isWebcamOn ? 'fa-video' : 'fa-video-slash'}`}></i>
        </button>
        <video
  ref={videoRef}
  autoPlay
  playsInline
  muted
  className="webcam-video"
/>
{isWebcamOn && (
  <canvas
    ref={outputCanvasRef}
    className="camerablur"
  />
)}

        
        </div>
    );
};

export default WebcamComponent; 